import {SOPutBacklog} from '../../core/backlog/so-put-backlog';
import {BacklogCore} from './backlog.core';
import {SOGetBacklog} from '../../core/backlog/so-get-backlog';
import {FormField, SelectionOption} from 'lionheartland';
import {putBacklogFormFieldOptions} from './put-backlog-form-fields';
import {AdapterProtocol} from 'lionheartland';
import {BasePut} from 'lionheartland';
import {ProjectCore} from '../project/project.core';
import {SOGetProject} from '../../core/project/so-get-project';
import {OrganizationCore} from '../organization/organization.core';
import {SOGetOrganization} from '../../core/organization/so-get-organization';

export class RAPutBacklog extends BasePut implements AdapterProtocol {
  formFieldOptions = Object.values(putBacklogFormFieldOptions);

  RequestClass = SOPutBacklog

  constructor(
    public entityCore: BacklogCore
  ) {
    super();
    if (putBacklogFormFieldOptions.project) {
      putBacklogFormFieldOptions.project.makeCore = true;
    }
  }

  onSet() {
    super.onSet()
  }

  prepareRequest() {
    this.request = new this.RequestClass(
      this.selectedEntity.uid,
      this.getFormValueFromIdentifier('name'),
      this.getFormValueFromIdentifier('description'),
      this.getFormValueFromIdentifier(
        'project',
        SOGetProject,
      ),
      this.getFormValueFromIdentifier(
        'organization',
        SOGetOrganization,
        true,
      ),
    )
  }


  onSelectionChange(field: FormField) {
    super.onSelectionChange(field)
  }

  fetchOptions(field: FormField) {
    super.fetchOptions(field)
  }

  getSelectionOption(field: FormField, entity): SelectionOption {
    return super.getSelectionOption(field, entity)
  }
}